import React, { FC, MouseEvent, useRef } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import Analytics from '@lib/Analytics'
import Pixels from '@lib/Pixels'
import { getPhoneNumber } from '@lib/PhoneNumber'
import { Button } from '@components/Button'
import { CallChatIcon, PhoneRingingIcon } from '@components/Icons'
import { MiniPopup } from '@components/Popup'
import { PhoneNumber } from '@components/PhoneNumber'
import {
  CallNowPopupWrapper,
  Heading,
  Label,
  Title,
  Description,
  SpeakText,
  ButtonsWrapper,
  btnStyles,
  callNowBtnStyles,
} from './CallNowPopup.elements'

type Props = {
  callHours?: string
  onClose: () => void
  onRequestCall: () => void
  phoneMapping: PhoneMapping
  variant: number
}

export const CallNowPopup: FC<Props> = props => {
  const {
    callHours = '8am - 8pm EST (Mon-Fri)',
    onClose,
    onRequestCall,
    phoneMapping,
    variant,
  } = props

  let title: string = ''
  let description: string = ''

  switch (variant) {
    case 2:
      title = 'Need help finding affordable coverage?'
      description = 'Let us do the work! Speak to a licensed insurance agent to shop & compare rates in your area.'
      break
    case 3:
      title = 'Have questions? Our top licensed insurance agents are here to help.'
      description = 'Call now to skip the line and lock in your plan options!'
      break
    default:
      title = 'One of our top licensed insurance agents just became available!'
      description = 'Call now to skip the line and lock in your plan options.'
      break
  }

  const popupRef = useRef<MiniPopup>(null)

  const handleClose = () => {
    const { current } = popupRef
    current && current.close()
  }

  const handleCall = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    const number = getPhoneNumber(phoneMapping)

    Pixels.callEvent()
    Analytics.log('Click To Call', {
      location: 'call-now-popup', info: `tel:${ number }`
    })

    window.location.href = `tel:${ number }`
  }

  const handleRequestCall = () => {
    handleClose()
    setTimeout(onRequestCall, 500)
  }

  return (
    <MiniPopup
      onClose={onClose}
      maxWidth={513}
      ref={popupRef}
    >
      <CallNowPopupWrapper>
        <Heading>
          <CallChatIcon />
          <Label>Good News</Label>
        </Heading>

        <Title variant={variant}>{title}</Title>
        <Description>{description}</Description>
        <SpeakText>{callHours}</SpeakText>

        <ButtonsWrapper>
          <Button
            variant="green"
            onClick={handleCall}
            aria-label="Speak to a licensed insurance agent"
            css={callNowBtnStyles}
          >
            <PhoneRingingIcon />
            <PhoneNumber
              mapping={phoneMapping}
              format="pretty"
            />
          </Button>

          <Button
            variant="green-outlined"
            onClick={handleRequestCall}
            css={btnStyles}
          >
            REQUEST A CALL
          </Button>
        </ButtonsWrapper>

      </CallNowPopupWrapper>
    </MiniPopup>
  )
}
